export { default as component } from "../../../../src/routes/[prefix]/(main)/+layout.svelte";